const initialState = {
  stepLabel: '',
  stepNumber: 1,
  totalSteps: 1,
  progressPercent: 0,
};

let state = initialState;

const listeners = new Set();

const notify = () => {
  listeners.forEach((listener) => listener(state));
};

export const getLiteHeaderState = () => state;

export const setLiteHeaderState = (nextState) => {
  state = { ...state, ...nextState };
  notify();
};

export const resetLiteHeaderState = () => {
  state = { ...initialState };
  notify();
};

export const subscribeLiteHeaderState = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
